import { trackEvent } from '.';

export function SensorListener() {
  const attrName = 'data-sensor';
  // @ts-ignore
  if (!window.__sensorListenerBound) {
    // @ts-ignore
    window.__sensorListenerBound = true;

    // 使用 pointerup 事件 - 统一处理鼠标和触摸
    document.addEventListener('pointerup', (e) => {
      // 只处理主按钮（左键/触摸）
      if (e.button !== 0) return;

      const target = e.target as HTMLElement | null;
      if (!target) return;

      const sensorEl = target.closest<HTMLElement>(`[${attrName}]`);
      if (!sensorEl) return;

      const sensorData = sensorEl.getAttribute(attrName) || '';

      console.log('pointerup', typeof sensorData, sensorData);
      try {
        const sensorDataObj = JSON.parse(sensorData);
        trackEvent.trackEmit(trackEvent.SENSORS_TRACK, sensorDataObj);
      } catch {
        trackEvent.trackEmit(trackEvent.SENSORS_TRACK, { event: sensorData });
      }
    });

    // 降级方案：如果浏览器不支持 pointer events，使用 click
    if (!window.PointerEvent) {
      document.addEventListener('click', (e) => {
        const target = e.target as HTMLElement | null;
        if (!target) return;

        const sensorEl = target.closest<HTMLElement>(`[${attrName}]`);
        if (!sensorEl) return;

        const sensorData = sensorEl.getAttribute(attrName) || '';

        console.log('click', sensorData);
        try {
          const sensorDataObj = JSON.parse(sensorData);
          trackEvent.trackEmit(trackEvent.SENSORS_TRACK, sensorDataObj);
        } catch {
          trackEvent.trackEmit(trackEvent.SENSORS_TRACK, { event: sensorData });
        }
      });
    }
  }
}
